import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="blog-page">
      <div className="section-eyebrow">Field Notes</div>
      <h1 className="font-display text-5xl lg:text-7xl uppercase mt-3">The Blog</h1>
      <p className="text-dim mt-3 max-w-xl">Behind the comic, behind the ring. Stories straight from the King.</p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-grid">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="scu-card group block" data-testid={`blog-card-${p.slug}`}>
            <div className="aspect-[16/10] overflow-hidden bg-black">
              <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-6">
              <div className="text-xs uppercase tracking-widest text-[#FF3B30]">{p.author}</div>
              <h3 className="font-display text-2xl uppercase mt-2 leading-tight">{p.title}</h3>
              <p className="text-dim mt-3 text-sm">{p.excerpt}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {p.tags?.map((t) => (
                  <span key={t} className="text-[10px] uppercase tracking-widest border border-white/15 px-2 py-1">{t}</span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
